export default __webpack_public_path__ + "static/media/thumb.d9c15397.png";